import Vue from 'vue'
import Vuex from 'vuex'
import rules from './rules.module'
import auth from './auth.module'
import user from './user.module'
import upload from './upload.module'
import person from './person.module'
import emailNotification from './emailNotification.module'
import lastGreeting from './lastGreeting.module'
import general from './general.module'
import reports from './reports.module'
import images from './images.module'
import videos from './videos.module'
import statistics from './statistics.module'
import timeline from './timeline.module'
import suggestedItems from './suggestedItems.module'
import documents from './documents.module'
import weeklyTales from './weeklyTales.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    rules,
    person,
    user,
    upload,
    emailNotification,
    lastGreeting,
    general,
    reports,
    images,
    videos,
    statistics,
    timeline,
    suggestedItems,
    documents,
    weeklyTales
  },
  state: {
    memoriesWallView: 'table',
    myMemoriesView: 'table',
    token: null,
    isAuthenticated: false,
    lang: "en",
    loading: false,
    langObj: {},
    snackbar: {
      value: false,
      color: 'pink',
      text: '',
      timeout: 3000
    },
  },
  mutations: {
    setMemoriesWallView(state, payload) {
      state.memoriesWallView = payload
    },
    setMyMemoriesView(state, payload) {
      state.myMemoriesView = payload
    },
    setToken(state, payload) {
      window.localStorage.setItem('token', payload)
      state.token = payload
    },
    loading(state, payload) {
      state.loading = payload
    },
    toast(state, payload) {
      state.snackbar.text = payload.message
      state.snackbar.value = true
      state.snackbar.color = payload.color
    },
    packages(modules, payload) {
      modules.person.packages = payload
    },
    currentUser(modules, payload) {
      modules.user.currentUser = payload
    },
    myEmailNotifications(modules, payload) {
      modules.emailNotification.myEmailNotifications = payload
    },
    reports(modules, payload) {
      modules.reports.reports = payload
    },
    reportInfo(modules, payload) {
      modules.reports.reportInfo = payload
    },
  },
  getters: {
    getMemoriesWallView(state) {
      return state.memoriesWallView
    },
    getMyMemoriesView(state) {
      return state.myMemoriesView
    },
    isAuthenticated(state) {
      return state.token !== null
    }
  },
})
